export const DEFAULT_PROFILE_PHOTO_URL =
  'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png';
export const DEFAULT_PROFILE_COVER_PHOTO_URL =
  'https://res.cloudinary.com/joegalaxy/image/upload/v1707443157/TimelineCovers.pro_miami-florida-coastline-cityscape-facebook-cover_q27ikm.jpg';

const GENERATED_AVATAR_MARKERS = [
  'noavatar_tsgpm9',
  '/images/noavatar',
  'ui-avatars.com/api',
];

export const isKnownDefaultCoverPhoto = (coverPhoto) => {
  const normalized = String(coverPhoto || '').trim().toLowerCase();
  if (!normalized) return false;
  return normalized === DEFAULT_PROFILE_COVER_PHOTO_URL.toLowerCase();
};

export const getAuthPlayer = (value) =>
  value?.data?.player || value?.player || value || null;

export const hasPersonalProfilePhoto = (profilePhoto) => {
  const normalized = String(profilePhoto || '').trim().toLowerCase();
  if (!normalized) return false;
  return !GENERATED_AVATAR_MARKERS.some((marker) =>
    normalized.includes(marker),
  );
};

export const hasPersonalCoverPhoto = (coverPhoto) => {
  const normalized = String(coverPhoto || '').trim().toLowerCase();
  if (!normalized) return false;
  if (isKnownDefaultCoverPhoto(normalized)) return false;
  return !GENERATED_AVATAR_MARKERS.some((marker) =>
    normalized.includes(marker),
  );
};

export const needsProfilePhotoCompletion = (value) => {
  const player = getAuthPlayer(value);
  if (!player) return false;
  return !hasPersonalProfilePhoto(player.profilePhoto);
};

export const needsCoverPhotoCompletion = (value) => {
  const player = getAuthPlayer(value);
  if (!player) return false;
  return !hasPersonalCoverPhoto(player.coverPhoto);
};

export const getProfileCompletionPath = (value, { focus = false } = {}) => {
  const player = getAuthPlayer(value);
  const playerId = String(player?.playerId || '').trim();
  const base = playerId ? `/profile/${encodeURIComponent(playerId)}` : '/profile';
  if (!focus) return base;
  const focusTarget = focus === true ? 'profilePhoto' : String(focus).trim();
  return focusTarget ? `${base}?focus=${encodeURIComponent(focusTarget)}` : base;
};
